<template>
  <div class="yxtbiz-signup-list">
    <div class="h64 lh64 align-right">
      <yxt-input class="pull-left w170" size="small" v-model="input" clearable placeholder="请输入"></yxt-input>
      <yxt-button @click.stop="handleCurrentChange(1)">搜索</yxt-button>
      <yxt-button type="primary" @click.stop="handleOpen">创建报名</yxt-button>
    </div>
    <yxt-table class="w100p" :data="data">
      <yxt-table-column prop="projectName" label="项目名称"></yxt-table-column>
      <yxt-table-column prop="appName" label="模块名称"></yxt-table-column>
      <yxt-table-column prop="projectStatusName" label="项目状态"></yxt-table-column>
      <yxt-table-column label="操作" align="left">
        <template slot-scope="scope">
          <span class="pointer c-cC436BFF" @click.stop="$emit('toManage', scope.row.id)">管理</span>
          <span class="pointer c-cC436BFF ml12" v-if="scope.row.projectStatus === 1" @click.stop="handlePublish(scope.row.id)">发布</span>
          <span class="pointer c-cC436BFF ml12" v-if="scope.row.projectStatus === 2" @click.stop="handlePause(scope.row.id)">暂停</span>
          <span class="pointer c-cC436BFF ml12" v-if="scope.row.projectStatus === 3" @click.stop="handleContinue(scope.row.id)">继续</span>
          <span class="pointer c-cC436BFF ml12" v-if="scope.row.projectStatus === 2 || scope.row.projectStatus === 3" @click.stop="handleEnd(scope.row.id)">结束</span>
        </template>
      </yxt-table-column>
    </yxt-table>
    <yxt-pagination class="mt24 align-right" @current-change="handleCurrentChange" :current-page="current" :page-size="size" layout="total, prev, pager, next" :total="total">
  </yxt-pagination>
    <yxt-dialog
      title="创建报名"
      :visible.sync="visible"
      :append-to-body="true"
      :before-close="handleClose"
    >
      <yxt-form>
        <yxt-form-item label="应用标识">
          <yxt-input v-model="params.appCode"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="项目id">
          <yxt-input v-model="params.appProjectId"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="项目名称">
          <yxt-input v-model="params.projectName"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="项目URL">
          <yxt-input v-model="params.appProjectUrl"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="封面URL">
          <yxt-input v-model="params.coverUrl"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="简介信息">
          <yxt-input v-model="params.intro"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="用户id">
          <yxt-input v-model="params.chargeUsers[0].id"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="用户姓名">
          <yxt-input v-model="params.chargeUsers[0].name"></yxt-input>
        </yxt-form-item>
        <yxt-form-item label="报名地址">
          <yxt-input v-model="params.shortUrl"></yxt-input>
        </yxt-form-item>
      </yxt-form>
      <span slot="footer" class="dialog-footer">
        <yxtf-button @click="handleClose">取 消</yxtf-button>
        <yxtf-button type="primary" @click="handleOk">确 定</yxtf-button>
      </span>
    </yxt-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      visible: false,
      data: [],
      current: 1,
      size: 20,
      total: 0,
      params: {
        appCode: 'te',
        projectName: '',
        coverUrl: `${this.$staticBaseUrl}ufd/55a3e0/o2o/pc/other/project.png`,
        intro: '',
        chargeUsers: [
          {
            id: '2fa409e8-841a-4033-972c-ce5b2f074553',
            name: 'admin'
          }
        ],
        appProjectId: '',
        appProjectUrl: '',
        shortUrl: ''
      }
    };
  },
  methods: {
    async handlePublish(id) {
      const SDK = this.$parent.SDK;
      const res = await SDK.publishProject(id);
      if (res.error) {
        alert(res.error.message);
      } else {
        this.current = 1;
        this.getManageProjects();
        alert('发布成功！');
      }
    },
    async handlePause(id) {
      const SDK = this.$parent.SDK;
      const res = await SDK.pauseProject(id);
      if (res.error) {
        alert(res.error.message);
      } else {
        this.current = 1;
        this.getManageProjects();
        alert('暂停成功！');
      }
    },
    async handleContinue(id) {
      const SDK = this.$parent.SDK;
      const res = await SDK.continueProject(id);
      if (res.error) {
        alert(res.error.message);
      } else {
        this.current = 1;
        this.getManageProjects();
        alert('继续成功！');
      }
    },
    async handleEnd(id) {
      const SDK = this.$parent.SDK;
      const res = await SDK.endProject(id);
      if (res.error) {
        alert(res.error.message);
      } else {
        this.current = 1;
        this.getManageProjects();
        alert('结束成功！');
      }
    },
    // 打开创建报名
    handleOpen() {
      this.visible = true;
    },
    // 关闭创建报名
    handleClose() {
      this.visible = false;
      this.params = {
        appCode: 'jiangshi',
        projectName: '',
        coverUrl: `${this.$staticBaseUrl}ufd/55a3e0/o2o/pc/other/project.png`,
        intro: '',
        chargeUsers: [
          {
            id: '2fa409e8-841a-4033-972c-ce5b2f074553',
            name: 'admin'
          }
        ],
        appProjectId: '',
        appProjectUrl: '',
        shortUrl: ''
      };
    },
    // 创建报名
    async handleOk() {
      const SDK = this.$parent.SDK;
      const res = await SDK.create(this.params);
      if (res.error) {
        alert(res.error.message);
      } else {
        this.handleClose();
        this.current = 1;
        this.getManageProjects();
        alert('创建成功！');
      }
    },
    // 获取管理
    async getManageProjects() {
      const SDK = this.$parent.SDK;
      const res = await SDK.getManageProjects({
        searchKey: this.input,
        limit: this.size,
        offset: (this.current - 1) * this.size
      });
      this.total = res.paging.count;
      this.data = (res.datas || []).map(_ => ({
        ..._,
        projectStatusName: {
          0: '已创建',
          1: '待发布',
          2: '已发布',
          3: '已暂停',
          4: '已结束',
          5: '未开始',
          6: '已过期'
        }[_.projectStatus]
      }));
    },
    // 切换页码
    handleCurrentChange(current) {
      this.current = current;
      this.getManageProjects();
    }
  },
  created() {
    this.getManageProjects();
  }
};
</script>
